export default defineNuxtRouteMiddleware(async (to) => {
  const { runWithContext } = useNuxtApp();
  const cartStore = useCartStore();
  const userStore = useUserStore();
  const { query } = to;

  /*
   * This has to run before the Promise.all as the checkAppleAndGooglePayEligibility()
   * result is needed for the cartStore.loadPaymentModes() api call.
   */
  await checkAppleAndGooglePayEligibility();

  await Promise.all([
    runWithContext(() => cartStore.loadCart({ fields: 'FULL' })),
    runWithContext(() => cartStore.loadPaymentModes()),
    runWithContext(() => (userStore.getIsAuthenticated ? userStore.loadAddresses() : null)),
  ]);

  return runWithContext(async () => {
    if (!cartStore.getReachedMinimumOrderValue || cartStore.getHasNoStockEntries) {
      return navigateToWithAdobeParam('/cart/', query);
    }

    if (!cartStore.getPhoneNumberIsValid) {
      return navigateToWithAdobeParam('/checkout/address/', query);
    }

    if (!cartStore.getBillingAddress) {
      return navigateToWithAdobeParam('/checkout/address/', query);
    }

    if (!cartStore.getDeliveryAddress) {
      return navigateToWithAdobeParam('/checkout/address/', query);
    }

    if (cartStore.getDeliveryAddressIsPickupStore) {
      try {
        await userStore.verifyAddress(cartStore.getDeliveryAddress);
      } catch (error) {
        return runWithContext(() =>
          navigateToWithAdobeParam('/checkout/address/', { ...query, error: 'invalidPickupStation' }),
        );
      }
    }

    if (cartStore.getFullPaybackPayment) {
      return runWithContext(() => navigateToWithAdobeParam('/checkout/summary/', query));
    }
  });
});
